module.exports = __webpack_public_path__ + "img/Number=6.118e8028.png";